import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentStatus } from '../../enums';
import { PaymentStatusPipe } from '../../pipes';

@Component({
  selector: 'app-payment-status',
  imports: [CommonModule, PaymentStatusPipe],
  templateUrl: './payment-status.component.html',
  styleUrl: './payment-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentStatusComponent {
  public readonly status = input.required<PaymentStatus>();
}
